import React, { useState } from 'react';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="app-header">
      <div className="logo">Mario Monteros</div>
      <button className="menu-toggle" onClick={toggleMenu}>
        <span className="hamburger"></span>
      </button>
      <nav className={`nav-links ${isMenuOpen ? 'open' : ''}`}>
        <a href="#projects" onClick={() => setIsMenuOpen(false)}>Proyectos</a>
        <a href="#contact" onClick={() => setIsMenuOpen(false)}>Contacto</a>
        <a href="https://github.com/Duartemario501" target="_blank" rel="noopener noreferrer">GitHub</a>
        <a href="https://www.linkedin.com/in/mario-monteros/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
      </nav>
    </header>
  );
};

export default Header;
